// TODO: Refactor

import { getUser } from 'src/entities/user'
import useTypedSelector from './useTypedSelector'

const useGetUser = () => useTypedSelector(getUser)

export default useGetUser
